import React from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image';
import { useRouter } from 'next/router';

import helper from '@utils/helper';

import { jumpPage } from '../../market/TradeList/utils';

import styles from './index.module.css';

export const ListWeb = ({ dataSource, page, dataBuried }) => {
  const router = useRouter();
  return dataSource.map((item) => (
    <List
      key={`${item.id}_${item.bid}_${item.coinText}`}
      record={item}
      page={page}
      dataBuried={dataBuried}
      router={router}
    />
  ));
};

export const List = ({ record, page, router, dataBuried }) => {
  const coinArr = record?.coinCode?.split('_') ?? [];
  const className = cn(styles.increase, 'DINPro-Medium', {
    [styles.greenText]: record?.riseAndFall > 0,
    [styles.redText]: record?.riseAndFall < 0
  });
  return (
    <div
      className={styles.container}
      onClick={() => jumpPage(router, record?.coinCode)}
      data-buried={dataBuried}
    >
      <div className={styles.coinCol}>
        <div className={styles.coinIcon}>
          {record.picturePath && (
            <Image
              src={record.picturePath}
              className="image_borderRadius_32"
              width={32}
              height={32}
              layout="fixed"
              alt={'kikitrade'}
            />
          )}
        </div>
        <div className={styles.coinText}>
          <h3 className={cn(styles.coinName, 'DINPro-Medium')}>
            {page === 'HOME_NEW' ? record.name : coinArr[0]}
          </h3>
          {page === 'HOME_NEW'
            ? (
                ''
              )
            : (
            <span className={cn(styles.currency, 'DINPro-Medium')}>
              /{coinArr[1]}
            </span>
              )}
        </div>
      </div>
      <div className={styles.latestPriceCol}>
        <span className={cn(styles.latestPrice1, 'DINPro')}>
          {record.formatPriceLast || '--'}
        </span>
      </div>
      <span className={className}>
        {record?.riseAndFall > 0 ? '+' : ''}
        {helper.formatFixNumString(Number(record?.riseAndFall ?? '0'), 2)}%
      </span>
    </div>
  );
};
